import { useEffect, useState } from "react";
import { User } from "lucide-react";

function getPictureSource(picture) {
  const value = typeof picture === "string" ? picture.trim() : "";
  if (!value) return null;
  if (/^(https?:|data:image\/)/i.test(value)) return value;
  if (value.startsWith("/")) return `${process.env.REACT_APP_BACKEND_URL}${value}`;
  return null;
}

export default function UserAvatar({
  picture,
  alt = "",
  className = "h-10 w-10 rounded-full",
  fallbackClassName = "h-10 w-10 rounded-full",
  iconClassName = "h-4 w-4",
}) {
  const [failed, setFailed] = useState(false);
  const source = getPictureSource(picture);

  useEffect(() => {
    setFailed(false);
  }, [picture]);

  if (source && !failed) {
    return (
      <img
        src={source}
        alt={alt}
        className={className}
        referrerPolicy="no-referrer"
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <div className={`flex items-center justify-center bg-[#fccf1f]/20 ${fallbackClassName}`} aria-label={alt || "Avatar indisponível"}>
      <User className={`text-[#fccf1f] ${iconClassName}`} />
    </div>
  );
}
